import React from 'react';
import Icon from '../../../components/AppIcon';

const LinkAnalytics = () => {
  const analyticsData = [
    {
      type: 'Standalone Visualizer',
      icon: 'ExternalLink',
      clicks: 1247,
      conversions: 89,
      conversionRate: 7.1,
      trend: 'up',
      trendValue: 12
    },
    {
      type: 'Client Dashboard',
      icon: 'LayoutDashboard',
      clicks: 856,
      conversions: 156,
      conversionRate: 18.2,
      trend: 'up',
      trendValue: 8
    },
    {
      type: 'Embed Version',
      icon: 'Code',
      clicks: 2134,
      conversions: 234,
      conversionRate: 11.0,
      trend: 'up',
      trendValue: 15
    },
    {
      type: 'QR Code Scans',
      icon: 'QrCode',
      clicks: 423,
      conversions: 67,
      conversionRate: 15.8,
      trend: 'down',
      trendValue: 3
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="BarChart3" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-text-primary">Link Analytics</h3>
        </div>
        <div className="text-xs text-text-secondary">Last 30 days</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {analyticsData?.map((item, index) => (
          <div key={index} className="bg-muted rounded-lg p-4 border border-border">
            <div className="flex items-center justify-between mb-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={item?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className={`flex items-center gap-1 text-xs font-medium ${
                item?.trend === 'up' ? 'text-success' : 'text-error'
              }`}>
                <Icon name={item?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
                {item?.trendValue}%
              </div>
            </div>

            <h4 className="text-sm font-medium text-text-secondary mb-2">{item?.type}</h4>
            
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-xs text-text-secondary">Clicks</span>
                <span className="text-sm font-semibold text-text-primary">
                  {item?.clicks?.toLocaleString()}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs text-text-secondary">Conversions</span>
                <span className="text-sm font-semibold text-text-primary">
                  {item?.conversions}
                </span>
              </div>
              <div className="pt-2 border-t border-border">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-text-secondary">Rate</span>
                  <span className="text-sm font-semibold text-primary">
                    {item?.conversionRate}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={16} className="text-primary mt-0.5 flex-shrink-0" />
          <div className="text-xs text-text-secondary">
            <p className="font-medium text-text-primary mb-1">Analytics Insights:</p>
            <p>Your embed version is performing exceptionally well with 2,134 clicks and an 11% conversion rate. Consider promoting this integration method to increase lead generation.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkAnalytics;